/**
 * Global guard for Vite's `vite:preloadError` event.
 *
 * React.lazy routes are already covered by lazyWithRetry, but a few
 * dynamic imports run outside React rendering — e.g. `await import(...)`
 * inside an event handler (App.tsx's cloneSystemTemplates) — and an
 * ErrorBoundary can't catch those. Vite fires `vite:preloadError` on
 * `window` whenever any dynamically imported chunk fails to load, which
 * after a deploy means a stale hash. We catch it here and reload to the
 * fresh shell, reusing the same time-windowed guard so a genuinely
 * missing chunk doesn't loop.
 *
 * Imported for its side effect from main.tsx, before <App> mounts.
 */

import { reloadForStaleChunk } from './lazyWithRetry'

window.addEventListener('vite:preloadError', (event) => {
  // If we kicked off a reload, suppress Vite's default rethrow — the page
  // is navigating away, so the error is moot. If the reload was declined
  // (we just reloaded and it's still failing), let the error surface
  // normally so a genuine failure isn't swallowed.
  if (reloadForStaleChunk()) event.preventDefault()
})
